import { AllyBase } from "../base";
import { AllyAttribute } from "../ally-attribute.class";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class makes elements effected by the attribute aria-hidden unfocusable.
 * 
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllyAriaHidden extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[0].push((scope) => {
                let self = scope.self;
                scope.self.attributeListeners.push(() => {
                    if (self.library.a11y.getAriaHidden(self.node) !== undefined) {
                        self.run({self: self, root: true}, {start: {x: 1}, end: {x: 1}});
                    }
                });
            });
            matrix[1].push((scope) => {
                let ariaHidden = scope.self.library.a11y.getAriaHidden(scope.self.node);
                if (!ariaHidden && scope.self.parentObject && scope.self.parentObject.variables.ariaHidden !== undefined) {
                    ariaHidden = scope.self.parentObject.variables.ariaHidden;
                }
                scope.self.variables.ariaHidden = ariaHidden;
                if (scope.self.variables[this.id + "-index"] === undefined) {
                    scope.self.variables[this.id + "-index"] = scope.self.attribute.createIndex(1);
                }
                let index = scope.self.variables[this.id + "-index"] as AllyAttribute["index"];
                if (ariaHidden) {
                    scope.self.attribute.setAttribute("tabindex", index, "-1");
                } else {
                    scope.self.attribute.setAttribute("tabindex", index, undefined);
                }
            });
        }, 4);
    }
}